import Client from "./Client";
// import RequestList from "./RequestList";

const Service = {
    url: 'admin/commissions',
    getDefault(){
        return {
            receipt_id: undefined,
            reseller_id: undefined,
            settlement_request_id: undefined,
            type: undefined,
            commission_rate: undefined,
            amount: undefined,
            created_at: undefined,
        }
    },
    /**
     * @params RequestList requestList
     * @return Request Promise
     **/
    async list(requestList) {
        return await Client.get(`${this.url}`, requestList.json());
    },
    async getOverviewReport(time_dimension, filters) {
        return await Client.get(`${this.url}/overview-report`, {
            time_dimension,
            filters
        });
    }
}

export default Service